module.exports = __webpack_public_path__ + "static/instructor-81fd2cd377ea2dc16269f88cf562765d.svg";